import request from '@/utils/request'

export class BaseClass {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T>(url: string, params?: any): Promise<T> {
    return request({
      url, method: 'GET', params
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<T>(url: string, data?: any, responseType = 'json', options = {}): Promise<T> {
    return request({
      url, method: 'POST', data, headers: { responseType }, ...options
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postForm<T>(url: string, data: any, responseType = 'json', options = {}): Promise<T> {
    return request({
      url, method: 'POST', data, headers: { responseType, 'Content-Type': 'multipart/form-data' }, ...options
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put<T>(url: string, data?: any): Promise<T> {
    return request({
      url, method: 'PUT', data
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  delete<T>(url: string, params?: any): Promise<T> {
    return request({
      url, method: 'DELETE', params
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  upload<T>(url: string, data: any): Promise<T> {
    return request({
      url, method: 'POST', data, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  export<T>(url: string, method: string, params: any): Promise<T> {
    const responseBlobType: 'arraybuffer' = 'arraybuffer'  as const

    const options = {
      url, method, responseType: responseBlobType, timeout: 0, data: null, params: null
    }
    if (method === 'POST') {
      options.data = params
    } else {
      options.params = params
    }
    return request(options)
  }
}